import { render } from "./CmpInfoCard.vue?vue&type=template&id=6b29dee7&ts=true"
import script from "./CmpInfoCard.vue?vue&type=script&lang=ts"
export * from "./CmpInfoCard.vue?vue&type=script&lang=ts"

import "./CmpInfoCard.vue?vue&type=style&index=0&id=6b29dee7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__